import { HttpTypes } from '@/types';
import { AgeRestrictionResponse } from '@/types/http/age-restriction';
import { AxiosInstance } from 'axios';

class AgeRestriction {
  private client: AxiosInstance;
  private routePath = '/sites';
  public host = '';

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async get(): Promise<HttpTypes.IResponse<AgeRestrictionResponse>> {
    const result = await this.client.get(`${this.routePath}/age-restriction`, {
      headers: {
        Origin: this.host,
        'X-Jstore-Host': this.host,
      },
    });
    return result.data;
  }
}

export default AgeRestriction;
